import { Edit, CheckCircle, CheckCircleOutline } from "@material-ui/icons";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "../../assets/img/no-record.png";
import {
  getSystemVersionsAction,
  updateSystemVersionStatusAction,
} from "../../actions/SystemVersionAction";

import * as code from "./../../config/Constants";
import moment from "moment";

class SystemVersionsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      systemVersions: [],
      totalVersions: 0,
      recordPerPage: code.RECORD_PER_PAGE,
      page: 0,
    };
  }
  columns = [
    {
      name: "Title",
      selector: "title",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Version",
      selector: "version",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Relese date",
      selector: "realseDate",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Status",
      selector: "status",
      width: "115px",
    },

    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];
  componentWillMount() {
    this.getAllSystemVersions(this.state.page);
  }

  getAllSystemVersions(pageIndex) {
    this.setState({
      showLoader: true,
    });
    this.props
      .getSystemVersionsAction(this.state.recordPerPage, pageIndex)
      .then((result) => {
        // console.log("result-69", result);
        if (result.status == 200 && Array.isArray(result.data.data)) {
          this.setState({
            systemVersions: result.data.data,
            totalVersions: result.data.total,
            showLoader: false,
          });
        } else {
          this.setState({
            showLoader: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  changePage = async (page) => {
    this.getAllSystemVersions(page - 1);
    // if (this.state.isSearched) {
    //   this.searchVendor(this.state.searchParam, page - 1);
    // } else {
    //   this.getVendorsList(page - 1);
    // }
  };

  changeStatus(versionId) {
    let data = {
      id: versionId,
    };
    this.props
      .updateSystemVersionStatusAction(data)
      .then((response) => {
        this.getAllSystemVersions(this.state.page);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let rows = [];
    for (var i = 0, len = this.state.systemVersions.length; i < len; i++) {
      let systemVersion = this.state.systemVersions[i];
      let data = {
        title: systemVersion.title,
        version: systemVersion.version,
        realseDate: systemVersion.realseDate
          ? moment(systemVersion.realseDate).format("MM-DD-YYYY")
          : "-",

        status: systemVersion.Isactive ? (
          <CheckCircle
            className="check"
            style={{ color: "green", cursor: "pointer" }}
            onClick={() => this.changeStatus(systemVersion._id)}
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            style={{ cursor: "pointer" }}
            onClick={() => this.changeStatus(systemVersion._id)}
          />
        ),

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                this.props.history.push({
                  pathname: "/systemVersionsForm",
                  state: {
                    id: systemVersion._id,
                  },
                });
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs="4">
            <h4 className="title-med mt-0 pt-1">System Versions</h4>
          </Col>
          <Col align="right" className="contact-btn">
            <Button
              variant="primary"
              className="btn-blue btn-head"
              onClick={() => {
                this.props.history.push({
                  pathname: "/systemVersionsForm",
                });
              }}
            >
              Add System Versions
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              pagination={true}
              paginationServer={true}
              paginationTotalRows={this.state.totalVersions}
              paginationPerPage={this.state.recordPerPage}
              onChangePage={(page) => this.changePage(page)}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getSystemVersionsAction,
    updateSystemVersionStatusAction,
  }
)(SystemVersionsList);
